import { CANCEL_AND_ADD_APPOINTMENT } from "./appointment.mutation";
import { DASHBOARD } from "../dashboard/dashboard.query";
import { GET_APPOINTMENTS } from "../appointment-list/appointment-list.query";
import { ICancelAndAddAppointmentRequest } from "./appointment.interface";
import { toastMessageActions } from "../../state/request";
import { useAppointmentStore } from "../../hooks/redux-hooks/appointment-store/appointment.store";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { useBookingAppointmentTypeStore } from "../../hooks";
import { IAppointmentCreateResponse } from "../create-appointment-v2/create-appointment-v2.interface";
export const useCancelAndAddAppointment = () => {
  const { selectedVisit: visitSelected, setRescheduleAppointmentsResponse, appointmentForm }=useAppointmentStore();
  const { appointmentTypeIndicator } = useBookingAppointmentTypeStore();


  const dispatch=useDispatch();
  const [
    update, { data, loading },
  ] = useMutation<{ cancelAndAddAppointment: IAppointmentCreateResponse }>(CANCEL_AND_ADD_APPOINTMENT);

  const updateAndCancelAppointment = () => {
    const appointmentRequest: ICancelAndAddAppointmentRequest = {
      appointmentFrom: "Web",
      appointmentId: visitSelected?.id!,
      appointmentType: visitSelected?.appointmentTypeId!,
      locationId: `${visitSelected?.location.idLocation!}`,
      petId: visitSelected?.pet.id,
      sales_resource: parseFloat(appointmentForm?.resourcesId!),
      start_at: parseInt(appointmentForm?.time!),
      appointmentCreateType: appointmentTypeIndicator,
    };

    update({
      variables: { data: appointmentRequest },
      refetchQueries: [
        { query: GET_APPOINTMENTS },
        { query: DASHBOARD },
      ],
    });
  };

  useEffect(() => {
    if (data) {
      if (data.cancelAndAddAppointment.success === false) {
        dispatch(toastMessageActions.setGlobalAlert({
          severity: "error",
          message: "Error occured while rescheduling, please try again with different time slot",
        }));
      } else {
        setRescheduleAppointmentsResponse(data.cancelAndAddAppointment);
      }
    }
  }, [data]);


  useEffect(() => {
    dispatch(toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  return {
    updateAndCancelAppointment,
    appointmentone: data?.cancelAndAddAppointment,
  };
};


